// /apps/patient/src/components/layout/PageHeader.tsx

import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';

interface PageHeaderProps {
  title: string;
  showBack?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ 
  title, 
  showBack = false, 
  actions = null,
  className = ''
}: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className={cn('flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4', className)}>
      <div className="flex items-center gap-2">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="hidden lg:block p-1 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#0fadc7]"
          >
            <ArrowLeft className="h-5 w-5 text-gray-600" />
          </button>
        )}
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}